export const PLAYERS_PER_PAGE = 50;
export const PLAYER_SCORES_PER_PAGE = 8;
export const LEADERBOARD_SCORES_PER_PAGE = 12;